import React, { useState } from 'react'
import { requestAPI } from '../../data/api'

const REASONS = [
	{ value: 'Whitelisted', label: 'Whitelisted' },
	{ value: 'SingleSale', label: 'Single sale' },
	{ value: 'Handout', label: 'Handout' },
	{ value: 'OtherReason', label: 'Other reason' },
	{ value: 'UnknownPhotographer', label: 'Unknown photographer' },
	{ value: 'UnknownDate', label: 'Unknown date' },
	{ value: 'OutOfCopyright', label: 'Out of copyright' },
	{ value: 'CounterpartyOnPicture', label: 'Counterparty on picture' },
	{ value: 'OtherUnclearReason', label: 'Other unclear reason' },
]

const RejectViolationModal = ({ violationId, clientId, onClose, onRejected }) => {
	const [reason, setReason] = useState('')
	const [comment, setComment] = useState('')
	const [submitting, setSubmitting] = useState(false)
	const [error, setError] = useState(null)

	const handleSubmit = async (e) => {
		e.preventDefault()
		if (!reason) {
			setError('Pick a reason')
			return
		}
		if (!clientId) {
			setError('Cannot reject — violation has no client_id')
			return
		}
		setSubmitting(true)
		setError(null)
		try {
			const response = await requestAPI('/cases/reject', 'POST', {
				case_id: violationId,
				clientId,
				non_violating_reason: reason,
				comment: comment.trim() || undefined,
			})
			if (response && response.message && !response.onHoldCasesCount && !response.awaitingReviewCasesCount) {
				setError(response.message)
				setSubmitting(false)
				return
			}
			onRejected()
		} catch (e) {
			setError('Failed to reject case')
			setSubmitting(false)
		}
	}

	return (
		<div className='vp-modal-backdrop' onClick={onClose}>
			<div className='vp-modal' onClick={(e) => e.stopPropagation()}>
				<h3 className='vp-modal-title'>Reject case</h3>
				<form onSubmit={handleSubmit}>
					<label className='vp-modal-label'>
						Reason
						<select
							className='vp-modal-input'
							value={reason}
							onChange={(e) => setReason(e.target.value)}
							required
						>
							<option value=''>— Select a reason —</option>
							{REASONS.map((r) => (
								<option key={r.value} value={r.value}>
									{r.label}
								</option>
							))}
						</select>
					</label>
					<label className='vp-modal-label'>
						Comment (optional)
						<textarea
							className='vp-modal-input'
							rows={4}
							value={comment}
							onChange={(e) => setComment(e.target.value)}
						/>
					</label>
					{error && <div className='vp-modal-error'>{error}</div>}
					<div className='vp-modal-actions'>
						<button
							type='button'
							className='vp-modal-cancel'
							onClick={onClose}
							disabled={submitting}
						>
							Cancel
						</button>
						<button
							type='submit'
							className='vp-modal-submit'
							disabled={submitting}
						>
							{submitting ? 'Rejecting…' : 'Reject case'}
						</button>
					</div>
				</form>
			</div>
		</div>
	)
}

export default RejectViolationModal
